import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Header from './Header';
import Work from './Work';
import Contact from './Contact';


const styles = theme => ({
root: {
  flexGrow: 1,
},
section: {
  height: '40em',
  width: '100%',

},
contact: {
  height: '10em',
  width: '100%',

},

});

class App extends Component {

  render() {
    const { classes } = this.props
    return (
      <div className="App">
        <Grid
          container
          className={classes.root}>
            <Grid item className={classes.section} xs={12}>
              <Header/>
            </Grid>
           <Grid item className={classes.section} xs={12}>
              <Work/>
            </Grid>
            <Grid item className={classes.contact} xs={12}>
              <Contact/>
            </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(App);
